import { render, staticRenderFns } from "./ShareWishistModal.vue?vue&type=template&id=1fa8f2a4&scoped=true&"
import script from "./ShareWishistModal.vue?vue&type=script&lang=js&"
export * from "./ShareWishistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa8f2a4",
  null
  
)

export default component.exports